import React from "react";
import { useSelector } from "react-redux";
import styles from "./AutoBetsNumberOfRounds.module.css";
import clickAudio from "../../audios/click.mp3";
import useSound from "use-sound";
import getSoundEffectVolume from "../../utils/getSoundEffectVolume";

const AutoBetsNumberOfRounds = ({ onChange, value, isChangeable }) => {
  const sounds = useSelector((state) => state.sounds);
  const MAX_ROUNDS = 999999999;
  const [playClickSound] = useSound(clickAudio, {
    volume: getSoundEffectVolume(),
    soundEnabled: !sounds.isSoundEffectsMute,
  });
  const clickSound = () => {
    playClickSound();
  };

  const handleBlur = () => {
    if (isChangeable) {
      if (value > 1 && value <= MAX_ROUNDS) {
        onChange(value);
      } else {
        onChange(1);
      }
    }
  };
  return (
    <div className={styles.controlGroup}>
      <label className={styles.inputLabel}>
        {isChangeable ? "Rounds" : "Remains Rounds"}
      </label>
      <span className={styles.betContainer}>
        <span className={styles.betInputWrapper}>
          <input
            type="number"
            style={{ position: "relative" }}
            className={`${styles.inputField} ${
              isChangeable ? styles.ableToClick : styles.disableToClick
            }`}
            value={value}
            step="any"
            min={1}
            max={MAX_ROUNDS}
            readonly={!isChangeable}
            onBlur={handleBlur}
            onChange={(e) => {
              if (isChangeable) {
                clickSound();
                const val = parseInt(e.target.value);
                onChange(val);
                localStorage.setItem("autoBetsNumberOfRounds", val);
              }
            }}
          />
        </span>
      </span>
    </div>
  );
};

export default AutoBetsNumberOfRounds;
